import * as yup from 'yup';

import { PlannedInvestmentAmount } from '@arrived/models';

export const accountsBasicInfoSchema = yup
  .object({
    firstName: yup.string().trim().required('user.firstName.required'),
    lastName: yup.string().trim().required('user.lastName.required'),
    /**
     * The `how did you hear about us?` field
     */
    leadReferral: yup.string().trim(),
    plannedInvestmentAmount: yup
      .mixed<PlannedInvestmentAmount>()
      .oneOf(Object.values(PlannedInvestmentAmount))
      .required('user.plannedInvestmentAmount.required'),
    agreedToTosPrivacy: yup.bool().oneOf([true], 'user.tosPrivacy.required'),
    referralCode: yup
      .string()
      .trim()
      .when('$referralCodeEnabled', {
        is: true,
        then: (schema) => schema.optional(),
        otherwise: (schema) => schema.strip(),
      }),
  })
  .defined();

export type AccountsBasicInfoSchema = yup.InferType<typeof accountsBasicInfoSchema>;
